
      import API from "!../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
      import domAPI from "!../../style-loader/dist/runtime/styleDomAPI.js";
      import insertFn from "!../../style-loader/dist/runtime/insertBySelector.js";
      import setAttributes from "!../../style-loader/dist/runtime/setAttributesWithoutAttributes.js";
      import insertStyleElement from "!../../style-loader/dist/runtime/insertStyleElement.js";
      import styleTagTransformFn from "!../../style-loader/dist/runtime/styleTagTransform.js";
      import content, * as namedExport from "!!../../css-loader/dist/cjs.js!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"../../node_modules/@faire/web/ui/ResponsiveContentV2/Viewport.css.ts.vanilla.css\",\"source\":\"\u0000#H4sIAAAAAAAAA72S3QqCMACF7/cU57Iuim0u/7rxVUYbuMglGqSE7x54YTFJpoaXg8N3zrctK7QyEvWl0tpCWoVdYezhadQjTxGFcdnsgRcBjtewlTan/QFQpi5vsk1h71afCdCRjmSTNEa5cHHsN27IBHMrZfMRiJY08hWSCaduZbhcgFEeuDjhYXDyyMye9WUpRG85mpuwZMZc3x8zqhHBqGYjm+i/bzmBGzLxNhe4dsob9SxswUsEAAA=\"}!./extracted.js";
      
      

var options = {};

options.styleTagTransform = styleTagTransformFn;
options.setAttributes = setAttributes;

      options.insert = insertFn.bind(null, "head");
    
options.domAPI = domAPI;
options.insertStyleElement = insertStyleElement;

var update = API(content, options);



export * from "!!../../css-loader/dist/cjs.js!./virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"../../node_modules/@faire/web/ui/ResponsiveContentV2/Viewport.css.ts.vanilla.css\",\"source\":\"\u0000#H4sIAAAAAAAAA72S3QqCMACF7/cU57Iuim0u/7rxVUYbuMglGqSE7x54YTFJpoaXg8N3zrctK7QyEvWl0tpCWoVdYezhadQjTxGFcdnsgRcBjtewlTan/QFQpi5vsk1h71afCdCRjmSTNEa5cHHsN27IBHMrZfMRiJY08hWSCaduZbhcgFEeuDjhYXDyyMye9WUpRG85mpuwZMZc3x8zqhHBqGYjm+i/bzmBGzLxNhe4dsob9SxswUsEAAA=\"}!./extracted.js";
       export default content && content.locals ? content.locals : undefined;
